import type { MediaFault } from '../../../composables/useDialer'

/**
 * Rep-facing copy for a degraded call. One module so the pill and the inline
 * notice can never drift.
 */
export const MEDIA_FAULT_LABELS: Record<MediaFault, string> = {
  bad_connection: 'Bad connection',
  choppy: 'Choppy connection',
  mic_silent: 'No audio from mic',
}

export interface MediaNotice {
  text: string
  action: 'redial' | null
}

// Only the call-killing faults earn the interruption; choppy stays in the pill.
const _NOTICES: Record<MediaFault, MediaNotice | null> = {
  bad_connection: { text: 'Bad connection — redial?', action: 'redial' },
  mic_silent: { text: 'No audio from mic — they can’t hear you.', action: null },
  choppy: null,
}

// Past this many bad-connection calls in a row it is the rep's own network, not
// the prospect's line.
export const MEDIA_FAULT_STREAK_LIMIT = 3

// No action: this is the rep's own network or headset, and nothing in Phone
// settings or Preferences configures either.
const _STREAK_NOTICE: MediaNotice = {
  text: 'Calls keep dropping audio. Check your network or headset.',
  action: null,
}

export function mediaNoticeFor(fault: MediaFault | null, streak: number): MediaNotice | null {
  if (!fault) return null
  if (streak >= MEDIA_FAULT_STREAK_LIMIT) return _STREAK_NOTICE
  return _NOTICES[fault]
}
